import { render, staticRenderFns } from "./BackToTop.vue?vue&type=template&id=57bf322f&"
import script from "./BackToTop.vue?vue&type=script&lang=js&"
export * from "./BackToTop.vue?vue&type=script&lang=js&"
import style0 from "./BackToTop.vue?vue&type=style&index=0&id=57bf322f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports